module.exports = __webpack_public_path__ + "static/media/video.9deb3e4e.mp4";